import clsx from 'clsx';
import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import downArrowIcon from './icon-down-arrow.svg';
import externalLinkIcon from './icon-external-link.svg';

type Props = {
  label: string;
  to?: string;
  href?: string;
  target?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  isSubMenu?: boolean;
  showSubMenu?: boolean;
  isExternal?: boolean;
};

export const MenuItem = ({ label, to, href, target, onClick, isSubMenu, showSubMenu, isExternal }: Props) => {
  return (
    <Body>
      {to ? (
        <Link to={to} target={target} onClick={onClick} style={{ cursor: 'pointer' }}>
          {label}
          <span></span>
          {isSubMenu && (
            <img
              src={downArrowIcon}
              alt="submenu toggle"
              style={{ cursor: 'pointer', transition: 'transform 0.2s', width: '1rem' }}
              className={clsx({ 'rotate-180': showSubMenu })}
            />
          )}
        </Link>
      ) : (
        <a href={href} target={target} onClick={onClick} style={{ cursor: 'pointer' }}>
          {label}
          {isExternal && <img src={externalLinkIcon} alt="external link" style={{ width: '1rem', marginLeft: '0.8rem' }} />}
          <span></span>
          {isSubMenu && (
            <img
              src={downArrowIcon}
              alt="submenu toggle"
              style={{ cursor: 'pointer', transition: 'transform 0.2s', width: '1rem' }}
              className={clsx({ 'rotate-180': showSubMenu })}
            />
          )}
        </a>
      )}
    </Body>
  );
};

const Body = styled.div`
  font-weight: 500;
  display: flex;
  padding: 0;

  & > a {
    display: flex;
    padding: 0.6rem 2.4rem;
    line-height: 2em;

    &:hover {
      background-color: #407edb1a;
    }

    font-size: 1.6rem;
    width: 100%;

    & > span {
      flex-grow: 1;
    }
  }
`;
